__turbopack_context__.v({
  "actionsNav": "BlogSection-module-scss-module__c7EH4a__actionsNav",
  "carouselWrapper": "BlogSection-module-scss-module__c7EH4a__carouselWrapper",
  "itemNavArrow": "BlogSection-module-scss-module__c7EH4a__itemNavArrow",
  "itemNavArrowLeft": "BlogSection-module-scss-module__c7EH4a__itemNavArrowLeft",
  "itemNavArrowRight": "BlogSection-module-scss-module__c7EH4a__itemNavArrowRight",
  "sectionWrapper": "BlogSection-module-scss-module__c7EH4a__sectionWrapper",
});
